module.exports = __webpack_public_path__ + "static/media/TeamTwitterIcon.c4f205e7.png";